import styled from 'styled-components';

import { NewStyleColor } from '../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../utils/style';

interface IconProps {
	isOpened: boolean;
}

const Wrapper = styled('button')`
	position: absolute;
	top: 50%;
	left: 100%;
	z-index: 10;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0;
	padding: 6px 0;
	border: 0;
	outline: 0;
	background-color: transparent;
	cursor: pointer;
	touch-action: none;
`;

const Inner = styled('div')`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 0 50% 50% 0;
	background-color: ${NewStyleColor.Grey900};

	&::before,
	&::after {
		content: '';
		position: absolute;
		left: 0;
		border: 11px solid transparent;
		border-left: 17px solid ${NewStyleColor.Grey900};
	}

	&::before {
		top: -10px;
	}

	&::after {
		top: 12px;
	}
`;

const Icon = styled('div')`
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	background-color: ${hexToRgba(NewStyleColor.White, 77)};

	svg {
		width: 8px;
		height: 8px;
		fill: ${NewStyleColor.Grey900};
		transform: ${({ isOpened }: IconProps) => `rotate(${isOpened ? '90deg' : '270deg'})`};
        margin: 0;
	}
`;

export {
	Wrapper,
	Inner,
	Icon,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Column/Toggle/styles.ts